import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import MenuRepository from "repositories/MenuRepository";

const initialState = {
  moduleMenu: null,
};

const moduleMenuSlice = createSlice({
  name: "moduleMenu",
  initialState,
  reducers: {
    setModuleMenu(state, { payload }) {
      state.moduleMenu = payload;
    },
  },
});

export const { actions } = moduleMenuSlice;
export default moduleMenuSlice.reducer;

export const useModuleMenuActions = () => {
  const dispatch = useDispatch();

  const loadModuleMenu = (slug) => {
    return MenuRepository.show(slug).then(({ data }) => {
      dispatch(moduleMenuSlice.actions.setModuleMenu(data));
      return data;
    });
  };

  return {
    loadModuleMenu,
  };
};
